import React from 'react';
import { connect } from 'react-redux';
import DataTable from 'react-data-table-component';
import Message from '../layout/Message';
import Button from '../layout/Button';

import {
    fetchPianoTechnicianList,
    fetchPianoTechnicianListForCompany,
    FIND_PIANOTECHNICIAN_STARTED,
    FIND_PIANOTECHNICIAN_SUCCEEDED,
    findPianoTechnician,
} from '../../actions/PianoTechnicianActions';

import {
    MAINTENANCE_TYPE_VIEW,
    MAINTENANCE_TYPE_ADD,
    defaultPianoTechnician,
} from '../../app-constants';

const mapStateToProps = state => ({
    pianoTechnician: state.pianoTechnician,
    pianoTechUser: state.pianoTechUser,
    pianoTechCompany: state.pianoTechCompany,
    user: state.user,
});

class PianoTechnicianTable extends React.PureComponent {
    componentDidMount() {
        //Retrieve list if they are not in state
        const { adminUser, simulatingUser } = this.props.user;

        if (adminUser && !simulatingUser) {
            if (!this.props.pianoTechnician.pianoTechnicianList || this.props.pianoTechnician.pianoTechnicianList.length === 0)
                this.props.dispatch(fetchPianoTechnicianList());
        } else {
            const { pianoTechCompany } = this.props.pianoTechCompany;
            if (!this.props.pianoTechnician.pianoTechnicianList || this.props.pianoTechnician.pianoTechnicianList.length === 0)
                this.props.dispatch(fetchPianoTechnicianListForCompany(pianoTechCompany.companyId));
        }

    }

    refreshList = () => {
        //Retrieve list if they are not in state
        const { adminUser, simulatingUser } = this.props.user;

        if (adminUser && !simulatingUser) {
            if (!this.props.pianoTechnician.pianoTechnicianList || this.props.pianoTechnician.pianoTechnicianList.length === 0)
                this.props.dispatch(fetchPianoTechnicianList());
        } else {
            const { pianoTechCompany } = this.props.pianoTechCompany;
            if (!this.props.pianoTechnician.pianoTechnicianList || this.props.pianoTechnician.pianoTechnicianList.length === 0)
                this.props.dispatch(fetchPianoTechnicianListForCompany(pianoTechCompany.companyId));
        }

    }

    addPianoTechnician = () => {
        const originalPianoTechnician = Object.assign({}, defaultPianoTechnician);

        const { pianoTechCompany } = this.props.pianoTechCompany;

        originalPianoTechnician.companyId = pianoTechCompany.companyId;

        const pianoTechnician = Object.assign({}, defaultPianoTechnician);
        pianoTechnician.companyId = pianoTechCompany.companyId;

        this.props.dispatch({
            type: FIND_PIANOTECHNICIAN_STARTED,
            maintenanceType: MAINTENANCE_TYPE_ADD,
            title: "Add PianoTechnician",
        });

        this.props.dispatch({
            type: FIND_PIANOTECHNICIAN_SUCCEEDED,
            pianoTechnician,
            originalPianoTechnician,
        });

    }

    viewPianoTechnician(techniciansId) {
        this.props.dispatch({
            type: FIND_PIANOTECHNICIAN_STARTED,
            maintenanceType: MAINTENANCE_TYPE_VIEW,
            title: "View PianoTechnician",
        });

        this.props.dispatch(findPianoTechnician(techniciansId));
    }

    render() {
        const columns = [
            {
                name: 'Technicians Id',
                selector: row => row.techniciansId,
                sortable: true,
                width: '6%',
            },
            {
                name: 'Company Id',
                selector: row => row.companyId,
                sortable: true,
                width: '6%',
            },
            {
                name: 'Technician Name',
                selector: row => row.technicianName,
                sortable: true,
                width: '10%',
            },
            {
                name: 'AddressLine1',
                selector: row => row.addressLine1,
                sortable: true,
                width: '8%',
            },
            {
                name: 'AddressLine2',
                selector: row => row.addressLine2,
                sortable: true,
                width: '8%',
            },
            {
                name: 'City',
                selector: row => row.city,
                sortable: true,
                width: '8%',
            },
            {
                name: 'State',
                selector: row => row.state,
                sortable: true,
                width: '8%',
            },
            {
                name: 'Country',
                selector: row => row.country,
                sortable: true,
                width: '8%',
            },
            {
                name: 'Email',
                selector: row => row.email,
                sortable: true,
                width: '10%',
            },
            {
                name: 'Phone',
                selector: row => row.encryptedPhone,
                sortable: true,
                width: '8%',
            },
            {
                name: 'Buttons',
                width: '8%',
                cell: row =>
                (
                    <>
                        <button
                            className="bluebutton2"
                            onClick={() => { this.viewPianoTechnician(row.techniciansId) }}
                            style={{ marginRight: "5px" }}
                        >View
                        </button>
                    </>
                )
            },
        ]
        const customStyles = {
            rows: {
                style: {
                    minheight: '20px',
                }
            }
        }

        return (
            <div>
                <Message message={this.props.pianoTechnician.message} type={this.props.pianoTechnician.messageType} />
                <table width="100%">
                    <tbody>
                        <tr>
                            <td className='lefttext'>
                                <Button className="bluebutton2" description="Refresh" onClick={this.refreshList} />
                                {this.props.user.allowAdd &&
                                    <Button className="bluebutton2" description="Add Technician" onClick={this.addPianoTechnician} />
                                }
                            </td>
                        </tr>
                    </tbody>
                </table>
                <DataTable
                    title='Piano Technicians'
                    className='app-table'
                    columns={columns}
                    customStyles={customStyles}
                    striped
                    data={this.props.pianoTechnician.pianoTechnicianList}
                    defaultSortField="technicianName"
                    highlightOnHover
                    pagination
                    onRowClicked={
                        (row) => { this.viewPianoTechnician(row.techniciansId) }
                    }
                />
            </div>
        );
    }

}

export default connect(mapStateToProps)(PianoTechnicianTable);
